import React, { Component } from "react";
import Strings from "@my-dld/assets/strings";
import PickerInput from "../Form/PickerInput";
import { RVSLookUp } from "@eres/rvsapi/entities";
import { I8N } from "@eres/core";

interface Props {
	complainTypes: RVSLookUp[];
	complainCategories: RVSLookUp[];
	onComplainTypeChange: ( type?: RVSLookUp ) => void;
}

export interface ComplainCategoryState {
	complainType?: RVSLookUp;
	complainCategory?: RVSLookUp;
}

interface State extends ComplainCategoryState {
	complainCategories: RVSLookUp[];
	error: { [ k: string ]: string };
}

class ComplainCategory extends Component<Props, State> {
	constructor( props: Props ) {
		super( props );
		this.state = {
			complainCategories: props.complainCategories,
			error: {},
		};
	}

	UNSAFE_componentWillReceiveProps( nextProps: Readonly<Props>, nextContext: any ) {
		const oldDetails = JSON.stringify( this.props.complainCategories );
		const newDetails = JSON.stringify( nextProps.complainCategories );
		if ( nextProps && oldDetails !== newDetails ) {
			const categories: RVSLookUp[] = nextProps.complainCategories;
			this.setState( {
				complainCategories: categories,
				complainCategory: undefined,
			} );
		}
	}

	render() {
		const { complainTypes } = this.props;
		const { error, complainType, complainCategories } = this.state;
		return <div className="card" id="ComplainCategory">
			<div className="card-header">
				<span>{ "2 - " + Strings.complain_category }</span>
			</div>
			<div className="card-body">
				<div className="row">
					<div className="col-md-12">
						<div className="mandatory-field-info">
							<small>{ Strings.mandatory_fields_note }</small>
						</div>
					</div>
					<div className="col-md-6">
						<PickerInput
							id={ "complainType" }
							holder={ this }
							required={ true }
							label={ Strings.complain_type }
							items={ complainTypes }
							formatter={ ( item: RVSLookUp ) => I8N.isRTL() ? item.NameAr : item.NameEn }
							toIdentifier={ ( item: RVSLookUp ) => item.ID + "" }
							error={ error.complainType }
							onValueChange={ ( type?: RVSLookUp ) => {
								this.props.onComplainTypeChange( type );
							} }/>
					</div>
					{ complainType && <div className="col-md-6">
						<PickerInput
							id={ "complainCategory" }
							holder={ this }
							required={ true }
							label={ Strings.complain_category }
							items={ complainCategories }
							formatter={ ( item: RVSLookUp ) => I8N.isRTL() ? item.NameAr : item.NameEn }
							toIdentifier={ ( item: RVSLookUp ) => item.ID + "" }
							error={ error.complainCategory }/>
					</div> }
				</div>
			</div>
		</div>;
	}

	public isValid(): Promise<ComplainCategoryState> {
		let isValid = true;
		const { complainType, complainCategory } = this.state;
		const error: { [ k: string ]: string } = {};
		if ( complainType == undefined ) {
			error.complainType = Strings.required;
			isValid = false;
		}
		if ( complainCategory == undefined ) {
			error.complainCategory = Strings.required;
			isValid = false;
		}
		this.setState( {
			error: error,
		} );
		if ( isValid ) {
			return Promise.resolve( this.state );
		}
		return Promise.reject( "ComplainCategory not Valid" );
	}

	public reset() {
		this.setState( {
			complainType: undefined,
			complainCategory: undefined,
			error: {},
		} );
	}
}

export default ComplainCategory;
